import React, { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import { db } from "../config/firebase";
import { collection, doc, getDoc, getDocs, query } from "firebase/firestore";
import { Loading } from "../components/Loading";
import { ButtonBg } from "../components/ButtonBg";

export const KeypointId = () => {
  const [book, setBook] = useState(null);
  const [keypoint, setKeypoint] = useState({});
  const { keypointId, id } = useParams();
  const bookDocRef = doc(db, "Books", id);
  const keypointsQuery = query(collection(bookDocRef, "keypoints"));
  const idx = keypointId.split("_")[1];

  useEffect(() => {
    const getBooks = async () => {
      try {
        const bookData = await getDoc(bookDocRef);
        setBook(bookData.data());
        const keypointsSnapshot = await getDocs(keypointsQuery);
        const keypointsData = keypointsSnapshot.docs.map((doc) => doc.data());
        const filterKeypoint = keypointsData.filter(
          (x) => +x.order + 1 === +idx
        );
        setKeypoint(filterKeypoint[0]);
      } catch (error) {
        console.log("error____ ", error);
      }
    };
    getBooks();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {!book ? (
        <div className="flex">
          <Loading />
        </div>
      ) : (
        <div className="flex flex-col p-5 md:p-10">
          <Link to={`/books/${id}`}>
            <ButtonBg text="< Back" classes="" />
          </Link>
          <h2 className="text-3xl font-semibold text-gray-950 pb-5 sm:text-4xl">
            {book.title}
          </h2>
          <h3 className="mb-1 text-2xl leading-tight text-gray-800 h-12">
            {book.author}
          </h3>
          {!keypoint ? (
            <div className="flex">
              <Loading />
            </div>
          ) : (
            <div className="bg-gray-100 h-auto min-h-max mt-10 rounded-2xl p-6 sm:p-8">
              <h2 className="text-2xl font-semibold text-gray-950 mb-7 sm:text-3xl">
                {keypoint?.name}
              </h2>
              <div
                className="keypointId text-2xl min-h-fit h-auto text-ellipsis"
                dangerouslySetInnerHTML={{ __html: keypoint.summary }}
              />
              <Link to={`/books/${id}`} className="mt-5 inline-block">
                <ButtonBg text="< Back" />
              </Link>
            </div>
          )}
        </div>
      )}
    </>
  );
};
